import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg"
import { getEstadosFincas, getSalesToExcel } from "../../../services";
import { UsuarioContext } from "../../../providers/userContext";

const ListadoFincas = ({ filtros }) => {
    //const listado = props?.fincas
    const { t } = useTranslation(['properties', 'common']);
    const user = useContext(UsuarioContext);
    const [listado, setListado] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const params = useParams();
    const url = params['*'].split('/')[0];
    const [disabled, setDisbled] = useState();
    const fetchData = async () => {
        setShow(true);
        setIsLoading(true);
        // Excluir searchTimestamp antes de enviar al backend
        const { searchTimestamp, ...filtrosData } = filtros;
        const response = await getSalesToExcel(url == 'aaff' ? { nif: params.nifFinca } : filtrosData);
        // const estadosFinca = JSON.parse(localStorage.getItem("states")) || [];
        let f = [];

        if (!response || response.length === 0) {
            setShow(false);
            setIsLoading(false);
            setListado([]);
            return;
        }else{
            const mapaUltimaVenta = new Map();
            response.forEach(d => {
                const key = `${d.properties?.nif}`;
                const existing = mapaUltimaVenta.get(key);
                if (!existing || new Date(d.saleDate) > new Date(existing.saleDate)) {
                    mapaUltimaVenta.set(key, d);
                }
            });
            const dataFiltrada = Array.from(mapaUltimaVenta.values());
            dataFiltrada.forEach(d => {
                let finca;
                const previousSale = d.previous_saleData
                const provsSinAcceso = previousSale?.provsSinAcceso;
                finca = {
                    "nifAAFF": d.aaff?.nif,
                    "nifComunidad": d.properties?.nif,
                    "fechaVenta": new Date(d.saleDate),
                    "trabajadores": previousSale?.detailsLopd?.workers ? t('common:status.yes') : t('common:status.no'),
                    "nifPresidente": d.properties?.nifPresidente,
                    "nombrePresidente":d.properties?.nombrePresidente,
                    "nifSPA": previousSale?.detailsLopd?.nifSPA ? previousSale?.detailsLopd?.nifSPA : "",
                    "razonSocialSPA": previousSale?.detailsLopd?.reasonSocialeSpa ? previousSale?.detailsLopd?.reasonSocialeSpa : "",
                    "videoVigilancia": previousSale?.detailsLopd?.surveillanceVideo ? t('common:status.yes') : t('common:status.no'),
                    "mantenimientoVideoVigilancia": previousSale?.detailsLopd?.maintenance ? t('common:status.yes') : t('common:status.no'),
                    "nifVideoVigilancia": previousSale?.detailsLopd?.nifCameraMaintenance ? previousSale?.detailsLopd?.nifCameraMaintenance : "",
                    "razonSocialVideoVigilancia": previousSale?.detailsLopd?.reasonCameraMaintenance ? previousSale?.detailsLopd?.reasonCameraMaintenance : "",
                    "nifAsesorLaboral": previousSale?.detailsLopd?.nifLaborAdviser ? previousSale?.detailsLopd?.nifLaborAdviser : "",
                    "razonSocialAsesorLaboral": previousSale?.detailsLopd?.reasonLaborAdviser ? previousSale?.detailsLopd?.reasonLaborAdviser : "",
                    "nifProvSinAcceso": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[0]?.nif : "",
                    "razonSocialProvSinAcceso": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[0]?.reasonSociale : "",
                    "servicioPrestado": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[0]?.serviceProvided : "",
                    "nifProvSinAcceso2": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[1]?.nif : "",
                    "razonSocialProvSinAcceso2": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[1]?.reasonSociale : "",
                    "servicioPrestado2": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[1]?.serviceProvided : "",
                    "nifProvSinAcceso3": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[2]?.nif : "",
                    "razonSocialProvSinAcceso3": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[2]?.reasonSociale : "",
                    "servicioPrestado3": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[2]?.serviceProvided : "",
                    "nifProvSinAcceso4": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[3]?.nif : "",
                    "razonSocialProvSinAcceso4": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[3]?.reasonSociale : "",
                    "servicioPrestado4": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[3]?.serviceProvided : "",
                    "nifProvSinAcceso5": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[4]?.nif : "",	
                    "razonSocialProvSinAcceso5": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[4]?.reasonSociale : "",
                    "servicioPrestado5": provsSinAcceso && provsSinAcceso.length > 0 ? provsSinAcceso[4]?.serviceProvided : "",
    };
                
                f.push(finca);
                setIsLoading(false);
                setListado(f);
            }); 
        }
       
    };
    const handleExportComplete = () => {
        setShow(false);
    };

    const exportarConDesplegables = async () => {
        try {
            // Crear workbook y worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(t('common:excel.worksheetName'));

            if (listado.length === 0) {
                handleExportComplete();
                return;
            }

            // Obtener headers
            const headers = Object.keys(listado[0]);

            // Configurar columnas con headers
            worksheet.columns = headers.map(header => ({
                header: header,
                key: header,
                width: 20
            }));

            // Aplicar estilo a los headers
            worksheet.getRow(1).font = { bold: true };
            worksheet.getRow(1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

            // Agregar datos
            listado.forEach(row => {
                worksheet.addRow(row);
            });

            // Ajustar ancho de columnas basado en contenido
            worksheet.columns.forEach(column => {
                let maxLength = column.header.length;
                column.eachCell({ includeEmpty: true }, cell => {
                    const cellValue = cell.value ? cell.value.toString() : '';
                    maxLength = Math.max(maxLength, cellValue.length);
                });
                column.width = Math.min(Math.max(maxLength + 2, 10), 50);
            });

            // Definir columnas con desplegables
            const dropdownColumns = [
                { columnName: 'videoVigilancia', options: ['SI', 'NO'] },
                { columnName: 'mantenimientoVideoVigilancia', options: ['SI', 'NO'] }
            ];

            // Agregar validación de datos (desplegables)
            dropdownColumns.forEach(({ columnName, options }) => {
                const columnIndex = headers.indexOf(columnName);

                if (columnIndex !== -1) {
                    const columnLetter = String.fromCharCode(65 + columnIndex); // A=65, B=66, etc.

                    // Aplicar validación a todas las filas de datos (no al header)
                    for (let i = 2; i <= listado.length + 1; i++) {
                        const cell = worksheet.getCell(`${columnLetter}${i}`);

                        cell.dataValidation = {
                            type: 'list',
                            allowBlank: true,
                            formulae: [`"${options.join(',')}"`],
                            showErrorMessage: true,
                            errorStyle: 'error',
                            errorTitle: t('common:excel.invalidValue'),
                            error: t('common:excel.selectOption', { options: options.join(', ') })
                        };
                    }
                }
            });

            // Generar archivo
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, t('management.lopdTemplateFileName') + '.xlsx');

            handleExportComplete();
        } catch (error) {
            console.error('Error al exportar:', error);
            handleExportComplete();
        }
    };

    useEffect(() => {
        const { grupoEnUso, searchTimestamp, ...filtrosSinGrupo } = filtros;
        const filtrosVacios = Object.keys(filtrosSinGrupo).length === 0;
        const servLopd = Number(filtrosSinGrupo.servp_id) === 2 || Number(filtrosSinGrupo.servp_id) === 4 || Number(filtrosSinGrupo.grupoServp_ids) === 2;
        setDisbled(filtrosVacios || !servLopd);
        if (url === 'aaff' || user.rol === 'AAFF') {
            setDisbled(false);
        }
        // Resetear el estado cuando cambien los filtros
        setShow(false);
        setIsLoading(false);
        setListado([]);
    }, [filtros.searchTimestamp, params.nifFinca]);
    return (
        <>
            {!show ?
                <button
                    className={`bigBtn ${disabled ? 'disabled' : ''}`}
                    onClick={() => fetchData()}
                >
                    <img src={Excel} alt={t('management.generateList')} width="30px" />
                    {t('management.generateLopdTemplate')}
                </button>
                :
                !isLoading ?
                    <button className='bigBtn' onClick={exportarConDesplegables}>
                        <img src={Excel} alt={t('management.exportList')} width="30px" />
                        {t('management.exportList')}
                    </button>
                    :
                    <span className='bigBtn' style={{ cursor: 'context-menu' }}><CircularProgress style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }} /> {t('management.generatingList')}</span>
            }
        </>
    );
}

export default withRouter(ListadoFincas);